// ─── Client mirror of the server's model-family detection ───────────────────
// supabase/functions/ai-proxy/dialects.ts decides, per model family, how a
// request is shaped. The client builds the director block and the stable
// prompt halves BEFORE the request leaves, so it needs the same answer from
// the same inputs: the writer's provider and model from Settings. Keep this
// function byte-for-byte in step with the server's detectDialect — a test
// compares the two over a table of ids.
export function detectDialect(providerId, model) {
  const p = String(providerId || '').toLowerCase().trim();
  const m = String(model || '').toLowerCase().trim().replace(/^~/, '');
  if (p === 'anthropic' || p.startsWith('claude') || /(^|\/)claude-|^anthropic\//.test(m)) return 'claude';
  if (p === 'gemini' || /(^|\/)gemini-|^google\//.test(m)) return 'gemini';
  if (p === 'deepseek' || /(^|\/)deepseek/.test(m)) return 'deepseek';
  if (p === 'openai' || /(^|\/)(gpt-|o[1-9](-|$)|chatgpt-)|^openai\//.test(m)) return 'openai';
  return 'generic';
}
